export const clarityProjectId = 'xejlxtapd9'